const CalendarCheckIcon = () => {
  return (
    <svg fill="none" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.0827 14.417V8.58366C26.0827 6.74271 24.5903 5.25033 22.7493 5.25033H5.24935C3.4084 5.25033 1.91602 6.74271 1.91602 8.58366V22.7503C1.91602 24.5913 3.4084 26.0837 5.24935 26.0837H12.7493M18.5827 23.5837L21.0827 26.0837C22.3327 22.3337 26.0827 20.2503 26.0827 20.2503M7.33268 1.91699V7.75032M20.666 1.91699V7.75032M6.91602 11.917H21.0827"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
      />
    </svg>
  )
}

export default CalendarCheckIcon
